import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { ILoanContractTemplate } from '@internal-models/loan-contract-template.model';

@Injectable({
	providedIn: 'root',
})
export class LoanContractTemplateProvider extends Provider<ILoanContractTemplate> {
	protected readonly url: string = '/loan-contract-templates';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public async getOne(): Promise<{ template: ILoanContractTemplate; variables: Array<string> }> {
		return this.process(this.api.get(`${this.url}`)) as Promise<{
			template: ILoanContractTemplate;
			variables: Array<string>;
		}>;
	}

	public createOrUpdate(
		templateId: string,
		template: Partial<ILoanContractTemplate>
	): Promise<ILoanContractTemplate> {
		return this.process(this.api.put(`${this.url}/${templateId}`, template)) as Promise<ILoanContractTemplate>;
	}
}
